{
  "OH_SALESTYPE": "Försäljningstyp",
  "PRODUCTS_NOT_IN_CAMPAIGN": "Artiklar ej i kampanj",
  "ORDER_AMOUNT_BELOW_FRIEGHT_FREE_LIMIT": "Lägg till varor för ",
  "ORDER_AMOUNT_BELOW_FREIGHT_FREE_LIMIT_2": " för att få fri frakt",
  "NOT_VALID_EMAIL": "Ej giltigt e-postmeddelande",
  "NAV_SALE_ASSORTMENT": "NAV_SALE_ASSORTMENT",
  "PRODUCT_EXPORT_NAV_BAR": "Produktexport",
  "PARCEL_TYPE": "Kollislag",
  "UNIFAUN_ARTICLE_TYPE": "Varuslag",
  "UNIFAUN_PICKUP_DATE": "Hämtningsdatum",
  "UNIFAUN_RETURN_INSTRUCTIONS_HELPER_TEXT": "ANGE UPPGIFTER FÖR HÄMTNING FRÅN AVSÄNDAREN OCH KOMPLETTERANDE UPPGIFTER",
  "UNIFAUN_RETURN_ROWS_HELPER_TEXT": "REGISTRERA DETALJERAD INFORMATION PER KOLLI",
  "ADD_PACKAGING_ROW": "Lägg till nytt kolli",
  "PICKUP_INSTRUCTIONS": "Hämtningsinstruktioner",
  "DELIVERY_INSTRUCTIONS": "Leveransanvisningar",
  "AMOUNT_RECIVED_WHEN_APPROVED": "Belopp att erhålla vid godkänd retur",
  "RETURN_INFORMATION": "Retur information",
  "RETURN_SERVICE_TYPE": "Returtjänst",
  "RETURN_LOCATION": "Returplats",
  "RETURN_SENDER": "Avsändare",
  "RETURN_PICKUP_ADDRESS": "Gatuadress",
  "RETURN_VALIDATION_CREATION": "Retur validering",
  "SHIPMENT_PRINTS": "Sändningsnummer:",
  "CREATING_RETURN_HEADER": "Skapning av retur",
  "CREATING_RETURN_INFO": "En retur skapas i Unifaun. Vänligen vänta...",
  "ERROR_CREATING_RETURN": "Ett fel uppstod vid skapning av returen. Justera fälten som skickas in och försök igen.",
  "SUCCESFULLY_CREATED_RETURN": "Returen har skapats. Skicka in ordern.",
  "DOWNLOAD_SHIPMENT_PDF": "Ladda ner retur PDF",
  "RETURNED_AMOUNT": "Returnerat antal",
  "CONSUMER_PACKAGE_LENGTH": "Konsumentförpackning, djup",
  "CONSUMER_PACKAGE_WIDTH": "Konsumentförpackning, bredd",
  "CONSUMER_PACKAGE_HEIGHT": "Konsumentförpackning, höjd",
  "CONSUMER_PACKAGE_WEIGHT": "Konsumentförpackning, vikt",
  "CONSUMER_PACKAGE_MATERIAL": "Konsumentförpackning, material",
  "DESIRED_PICKUP_DATE": "Önskat upphämtningsdatum",
  "PARCEL": "Kolli",
  "SUBMIT_RETURN_ORDER": "Skicka returorder",
  "PICKUP_ADDRESS": "Upphämtningsadress",
  "OH_ORDLEVADR1": "Namn",
  "OH_ORDLEVADR2": "C/o",
  "OH_ORDLEVADR3": "Adress",
  "CURRENT_CUSTOMER": "Aktuell kund",
  "CLEARANCE_ARTICLES": "Utförsäljning",
  "RETUR_NOPRICE": "Användare utan pris",
  "CLICK_SHIPMENT_PRINT":"Klicka på sändningsnumret för att skriva ut din fraktsedel",
  "ALRIK_HEDLUND_CUSTOM_FIELDS": "Alrik Headlund anpassade fält",
  "HIDE_INVOICES_CHECKBOX": "Dölj fakturaflik",
  "OPENED_ACTIVITIES": "Kommande aktiviteter",
  "EXPIRED_ACTIVITIES": "Förfallna aktiviteter",
  "ALL_ACTIVITIES": "Alla aktiviteter",
  "ACTIVITY_TIME": "Aktivitetsstart",
  "ARTICLE_CATEGORY": "Artikelkategori",
  "MEETING_TYPE": "Mötestyp",
  "SPOKEN_IN_STORE": "Har du pratat med någon i butik?",
  "ACTIVITY_END_TIME": "Aktiviteten slutar",
  "SALES_CODE_IN_ERP": "Försäljningskod i ERP",
  "MEETIGN_AMOUNT": "Antal möten",
  "TOTAL_LAST_MONTH": "Totalt förra månaden",
  "TOTAL_THIS_MONTH": "Totalt denna månad",
  "COMPLETED_THIS_MONTH": "Avslutad denna månad",
  "COMPLETED_LAST_MONTH": "Färdigställd förra månaden",
  "MEETINGS_TARGET": "Framsteg denna månad",
  "MEETINGS_LAST_MONTH_TARGET": "Framsteg förra månaden",
  "CONVERTED_IN_ORDER_THIS_MONTH": "Faktiska månadsmöten genererade ordning",
  "CONVERTED_IN_ORDER_LAST_MONTH": "Föregående månads möten genererade ordning",
  "EXPORT_PRODUCT_STOCK_HEDLUND": "Exportera lagerinformation Hedlundgruppen",
  "EXPORT_PRODUCT_STOCK_CULT": "Exportera lagerinformation Cult",
  "RETURN_VALID": "Returrätt",
  "MINIMUM_ORDER_VALUE": "Observera att 1000 SEK är det minsta orderbeloppet."
}
